import { render, staticRenderFns } from "./QuestionnaireViewSectionTable.vue?vue&type=template&id=8dfab0c6"
import script from "./QuestionnaireViewSectionTable.vue?vue&type=script&lang=js"
export * from "./QuestionnaireViewSectionTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireViewSectionTable.vue?vue&type=style&index=0&id=8dfab0c6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports